import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPoint, NavEntryPointV3 } from '@retailer-platform/dashboard/routing'

import { cartAssistantRouter } from './routing/cartAssistantRouter'
import { cartAssistantEditorAccessControl } from './access-control/cartAssistantEditorAccess.configuration'
import { Permission } from './access-control/permissions'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'cart-assistant',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component.
    // Register the real Totem entity with `pnpm ipp domain register cart-assistant` as a follow-up.
    tool: 'cart-assistant-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    // Uncomment to lazy load your domain's foreign dictionaries
    // ES_ES: () => import('./translations/es-ES.json'),
    // FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    // Warehouse-less URLs (`/partners/:partner_id/cart-assistant/sites/:storeConfigId/...`, no
    // `/warehouses/:warehouse_id`) mount under the partner-scoped section, so the router lives in the
    // `partnerScoped` bucket — not `scoped`, which is for retailer-scoped (warehouse-in-URL) routes.
    partnerScoped: [cartAssistantRouter],
  },
  navigationEntries: [
    {
      attachToV2: NavEntryPoint.Merchandising,
      subNavItems: [
        {
          type: 'item',
          llmDescription:
            'Configure the cart assistant: display name, entry-point badge, landing greeting and disclaimer, support and learn-more links, tone, and the cold-start prompt starters',
          labelId: 'cartAssistantDomain.onboarding.pageTitle',
          route: 'cart-assistant-editor',
          subRoutes: ['cart-assistant-cold-start-prompts'],
          accessControl: cartAssistantEditorAccessControl,
          position: 9,
          positionNavV2: 9,
          inToolPermissions: [
            {
              slug: Permission.StoreConfigsModify,
              permissionLabelId: 'permissionAccordion.permissions.' + Permission.StoreConfigsModify,
            },
          ],
        },
      ],
    },
    {
      attachToV3: NavEntryPointV3.StorefrontPro,
      subNavItems: [
        {
          type: 'item',
          llmDescription:
            'Configure the cart assistant: display name, entry-point badge, landing greeting and disclaimer, support and learn-more links, tone, and the cold-start prompt starters',
          labelId: 'cartAssistantDomain.onboarding.pageTitle',
          route: 'cart-assistant-editor',
          subRoutes: ['cart-assistant-cold-start-prompts'],
          accessControl: cartAssistantEditorAccessControl,
          positionNavV3: 18,
          inToolPermissions: [
            {
              slug: Permission.StoreConfigsModify,
              permissionLabelId: 'permissionAccordion.permissions.' + Permission.StoreConfigsModify,
            },
          ],
        },
      ],
    },
  ],
  adminNavigationEntries: [],
  // NOTE TO DEV: run `pnpm ipp domain register <your-system-name>` to register your domain with Totem here
}

export default definition
